import { useState, useEffect } from "react";

const CboFPago = ({ selectedValue, onChange, disabled }) => {

  const [turnos, setTurnos] = useState([])

  useEffect(() => {

    var json3;
    var jsons3;
    var url3;
    let consulta = new Object();

 //   consulta.modo = 1;
 //   consulta.empresa = 1;

    jsons3 = JSON.stringify(consulta);


    var options3 = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'

      },
      mode: 'cors',
      credential: 'include',
      body: jsons3,

    };
    console.log("Formas de Pago");
    url3 = `${process.env.REACT_APP_API_URL}/fpa/allfpagos`;



    fetch(url3, options3)
      .then(response => response.json())
      .then(data => {

        json3 = data.data;
        setTurnos(json3[0]);

      })


  }, []);


  return (

    <select className="form-control form-select mb-3 " value={selectedValue} onChange={onChange} disabled={disabled}  >
      <option value="0"></option>

      {turnos.map((unolista, index) => (
        <option key={index + '_opt'} value={unolista.Fpa_IdPfa}>{unolista.Fpa_Descrip}</option>
      )
      )
      }

    </select>
  );
};

export default CboFPago;